(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.pickTime = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.datePicker = datePicker;
  exports.getTimes = getTimes;
  exports.getDays = getDays;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function datePicker() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this = this;

    var format = arguments[1];
    var doc = arguments[2];

    var CHOICE_OPTIONS = Object.assign({}, options);
    var yearsArr = CHOICE_OPTIONS.yearsArr,
        monthsArr = CHOICE_OPTIONS.monthsArr,
        datesArr = CHOICE_OPTIONS.datesArr,
        currentYear = CHOICE_OPTIONS.currentYear,
        currentMonth = CHOICE_OPTIONS.currentMonth,
        currentDate = CHOICE_OPTIONS.currentDate;

    var time = doc.querySelectorAll('.nx-time-list');
    var isHaveTime = { isHaveYear: false, isHaveMonth: false, isHaveDate: false };
    format.forEach(function (elem, index) {
      switch (elem) {
        case 'YYYY':
          isHaveTime.isHaveYear = true;
          time[index].innerHTML = assignVal(yearsArr);
          _this.selectedYear = currentYear;
          break;
        case 'MM':
          isHaveTime.isHaveMonth = true;
          time[index].innerHTML = assignVal(monthsArr);
          _this.selectedMonth = currentMonth;
          break;
        case 'DD':
          isHaveTime.isHaveDate = true;
          time[index].innerHTML = assignVal(datesArr);
          _this.selectedDate = currentDate;
          break;
      }
    });
    var that = this;

    var datePicker = function () {
      function datePicker(obj) {
        var initIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var callback = arguments[2];

        _classCallCheck(this, datePicker);

        this.obj = obj;
        this.index = -initIndex;
        this.callback = callback;
        this.length = this.obj.children.length;
        this.distance = this.obj.children[0] ? this.obj.children[0].offsetHeight : null;
        this.ready();
      }

      _createClass(datePicker, [{
        key: 'ready',
        value: function ready() {
          datePicker.setTranslate3d(this.obj, this.index * this.distance);
          datePicker.setRotateX(this.obj.children, this.index);
          this.bind(this.obj);
        }
      }, {
        key: 'bind',
        value: function bind(selector) {
          var _this2 = this;

          var iStartPageY = 0,
              step = 1,

          // eslint-disable-next-line no-unused-vars
          prevPoint = 0,
              length = this.length - 1;

          var touchstart = function touchstart(e) {
            e.preventDefault();
            e.stopPropagation();
            iStartPageY = e.changedTouches[0].clientY;
            prevPoint = iStartPageY;
          };
          var touchmove = function touchmove(e) {
            e.preventDefault();
            e.stopPropagation();
            var iDisY = e.changedTouches[0].pageY - iStartPageY;
            prevPoint = e.changedTouches[0].pageY;
            if (_this2.index == 0 && iDisY > 0 || _this2.index == -length && iDisY < 0) {
              step = 1 - Math.abs(iDisY) / selector.clientWidth;
              step = Math.max(step, 0);
              iDisY = parseInt(iDisY * step);
            }
            datePicker.setTranslate3d(selector, _this2.index * _this2.distance + iDisY);
            datePicker.setRotateX(_this2.obj.children, _this2.index + iDisY / _this2.distance);
          };
          var touchend = function touchend(e) {
            e.preventDefault();
            e.stopPropagation();
            var iDisX = e.changedTouches[0].pageY - iStartPageY;
            _this2.index += Math.round(iDisX / _this2.distance);
            _this2.index = _this2.index > 0 ? Math.min(_this2.index, 0) : Math.max(_this2.index, -length);
            _this2.index = _this2.index > 0 ? 0 : _this2.index < -length ? -length : _this2.index;
            datePicker.setTranslate3d(selector, _this2.index * _this2.distance);
            datePicker.setRotateX(_this2.obj.children, _this2.index);
            _this2.callback && _this2.callback(Math.abs(_this2.index));
          };
          selector.addEventListener('touchstart', touchstart, false);
          selector.addEventListener('touchmove', touchmove, false);
          selector.addEventListener('touchend', touchend, false);
        }
      }], [{
        key: 'setTranslate3d',
        value: function setTranslate3d(obj, dis) {
          obj.style.transform = 'translate3d(0,' + dis + 'px,0)';
        }
      }, {
        key: 'setRotateX',
        value: function setRotateX(obj, index) {
          var activeFontSize = getComputedStyle(doc).fontSize;
          var activeLineHeight = getComputedStyle(doc).lineHeight;
          Array.from(obj).forEach(function (ele, i) {
            var indexVal = Math.abs(index + i);
            obj[i].style.fontSize = parseFloat(activeFontSize, 10) * Math.pow(0.65, indexVal) + 'px';
            obj[i].style.lineHeight = indexVal == 0 ? parseFloat(activeLineHeight, 10) * 1.2577 + 'px' : activeLineHeight;
            if (indexVal == 0) {
              obj[i].style.color = '#415fff';
            } else if (indexVal == 1) {
              obj[i].style.color = '#818181';
            } else {
              obj[i].style.color = '#CDCDCD';
            }
          });
        }
      }]);

      return datePicker;
    }();

    if (isHaveTime.isHaveYear) {
      new datePicker(time[0], findIndexValue(yearsArr, currentYear), function (indexDay) {
        that.selectedYear = yearsArr[indexDay];
        if (isHaveTime.isHaveDate) {
          datesArr = getDays(that.selectedYear, that.selectedMonth);
          time[2].innerHTML = assignVal(datesArr);
          that.selectedDate = that.selectedDate > datesArr.length ? datesArr[datesArr.length - 1] : that.selectedDate;
          new datePicker(time[2], findIndexValue(datesArr, that.selectedDate), function (indexMinute) {
            that.selectedDate = datesArr[indexMinute];
          });
        }
      });
    }
    if (isHaveTime.isHaveMonth) {
      new datePicker(time[1], findIndexValue(monthsArr, currentMonth), function (indexHour) {
        that.selectedMonth = monthsArr[indexHour];
        if (isHaveTime.isHaveDate) {
          datesArr = getDays(that.selectedYear, that.selectedMonth);
          time[2].innerHTML = assignVal(datesArr);
          that.selectedDate = that.selectedDate > datesArr.length ? datesArr[datesArr.length - 1] : that.selectedDate;
          new datePicker(time[2], findIndexValue(datesArr, that.selectedDate), function (indexMinute) {
            that.selectedDate = datesArr[indexMinute];
          });
        }
      });
    }
    if (isHaveTime.isHaveDate) {
      new datePicker(time[2], findIndexValue(datesArr, that.selectedDate), function (indexMinute) {
        that.selectedDate = datesArr[indexMinute];
      });
    }
  }
  function assignVal(arr) {
    var doc = '';
    arr.forEach(function (ele) {
      ele = ele < 10 ? '0' + ele : ele;
      doc += '<li>' + ele + '</li>';
    });
    return doc;
  }
  function getMaxDay(year, month) {
    year = parseFloat(year);
    month = parseFloat(month);
    if (month === 2) {
      return isLeapYear(year) ? 29 : 28;
    }
    return [4, 6, 9, 11].indexOf(month) >= 0 ? 30 : 31;
  }
  function isLeapYear(year) {
    return year % 100 !== 0 && year % 4 === 0 || year % 400 === 0;
  }
  function findIndexValue(arr, val) {
    return arr.findIndex(function (elem) {
      return elem == val;
    });
  }
  function getTimes(min, max) {
    var rs = [];
    while (min <= max) {
      rs.push(min);
      min++;
    }
    return rs;
  }
  function getDays(year, month) {
    return getTimes(1, getMaxDay(year, month));
  }
});